const isNumeric = (n: number) => String(n).length > 0 && !Number.isNaN(+n);

export { isNumeric };
